export const profileEdit = {
  back: '← 마이페이지로 돌아가기',
  heading: '프로필 편집',
  subtitle: '변경하고 싶은 항목을 편집해 주세요',

  // 라벨
  nameLabel: '이름 *',
  namePlaceholder: '닉네임도 가능합니다',
  genderLabel: '성별',
  countryLabel: '거주 국가',
  countryPlaceholder: '일본',
  timezoneLabel: '시간대 *',
  nativeLabel: '모국어 * (복수 선택 가능)',
  learningLabel: '학습 언어 * (복수 선택 가능)',

  // 셀렉트
  selectPlaceholder: '선택해 주세요',
  genderFemale: '여성',
  genderMale: '남성',
  genderOther: '기타',

  // 유효성 검사·상태
  validationRequired: '필수 항목을 입력해 주세요',
  success: '✅ 저장했습니다! 마이페이지로 돌아갑니다...',
  saving: '저장 중...',
  submit: '변경 사항 저장',
};
